import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Button, Col, Flex, Form, Input, Row, Table, Spin } from "antd";
import { PageHeader } from "../../components/PageHeader/PageHeader";

import { Breadcrumbs } from "../../components/Breadcrumbs/Breadcrumbs";
import { buildQueryString, debounce } from "../../utils/helpers";
import { IconDownload } from "../../components/IconDownload/IconDownload";
import { IconSearch } from "../../components/IconSearch/IconSearch";
import { MainButton } from "../../components/MainButton/MainButton";
import { Notification } from "../../components/Notification/Notification";
import { SalesSummary } from "../SalesSummary/SalesSummary";
import { Goods } from "../GoodsIn/GoodsIn";
import { SearchBox } from "../SearchBox/SearchBox";
import { SectionHeader } from "../../components/SectionHeader/SectionHeader";
import { CurrentOrders } from "../CurrentOrders/CurrentOrders";
import { SalesOrders } from "../SalesOrders/SalesOrders";
import { SalesTerritories } from "../SalesTerritories/SalesTerritories";
import { Shipments } from "../Shipments/Shipments";
import { getProductMetadata, clearData } from "../Dashboard/dashboardSlice";
import { CSVLink } from "react-csv";
import { WarningMessage } from "../../components/WarningMessage/WarningMessage";	


import css from "../Dashboard/Dashboard.module.css";

export const Details = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const handleBack = () => {
    navigate(-1);
  };

  const { upc } = useParams();
  useEffect(() => {
    dispatch(getProductMetadata(upc));
    return () => {
      dispatch(clearData());
    };
  }, [upc]);  
  
  const { productMetadata, getProductMetadataInProgress } = useSelector((state) => state.dashboard);
  
  const renderHeader = () => {
    if(getProductMetadataInProgress)
      return <Spin size="small" />;
    let header;
    if(productMetadata && productMetadata.title) {
      console.log(productMetadata.artists);
      const artist = (Array.isArray(productMetadata.artists) && productMetadata.artists.length>0)? productMetadata.artists[0].name : null;
      header = `${productMetadata.title} (${productMetadata.catalog_number}) ${artist ?  ' by ' + artist : ''} released on ${productMetadata.release_date}`;
    } else {
      header = `Product Details - ${upc}`;
    } 
    return <PageHeader title={header} />;
  }
  
  return (<>
    <div className={css.backButtonContainer}>
      <Button type="primary" htmlType="submit" onClick={handleBack}>Back to Results</Button>
    </div>
  	<Breadcrumbs paths={[{path: `/details/${upc}`, breadcrumbName: `Product Details - ${upc}`}]} />
    {renderHeader()}
    <Flex className={css.root} vertical>
	  <WarningMessage />
      {upc && <>
        <div className={"ibox-holder"}><SalesTerritories upc={upc} /></div>
        <div className={"ibox-holder"}><Shipments upc={upc} /></div>
        </>}
    </Flex>
  </>
  );
};
